import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './components/Hero';
import ProductList from './components/ProductList';
import ProductPage from './components/ProductPage';
import FAQ from './components/FAQ';
import About from './components/About';
import Contact from './components/Contact';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Register from './components/Register';

// ✅ NEW: scroll-to-top on route changes
import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      {/* Runs on every navigation */}
      <ScrollToTop />

      <div className="min-h-screen bg-cream-bg text-gray-900">
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <ProductList />
              </>
            }
          />
          <Route path="/products" element={<ProductList />} />
          <Route path="/products/:id" element={<ProductPage />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/register" element={<Register />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
